export const AccountScoreGauge = ({ score = 0, summary }) => {
  const numericScore = Math.max(0, Math.min(10, Number(score) || 0));
  const pct = (numericScore / 10) * 100;
  const tone = numericScore >= 8 ? "#32D74B" : numericScore >= 6 ? "#0A84FF" : numericScore >= 4 ? "#FF9F0A" : "#FF453A";

  // SVG arc gauge
  const radius = 70;
  const circ = 2 * Math.PI * radius;
  const dash = (pct / 100) * circ * 0.75; // 270deg arc
  const totalArc = circ * 0.75;

  return (
    <div className="bg-[#141414] border border-[#262626] rounded-sm p-6 flex flex-col md:flex-row items-center gap-8" data-testid="account-score-gauge">
      <div className="relative w-44 h-44 shrink-0">
        <svg width="176" height="176" viewBox="0 0 176 176" className="-rotate-[135deg]">
          <circle
            cx="88" cy="88" r={radius}
            fill="none"
            stroke="#262626"
            strokeWidth="6"
            strokeDasharray={`${totalArc} ${circ}`}
          />
          <circle
            cx="88" cy="88" r={radius}
            fill="none"
            stroke={tone}
            strokeWidth="6"
            strokeLinecap="butt"
            strokeDasharray={`${dash} ${circ}`}
            style={{ transition: "stroke-dasharray 1s ease-out" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="font-mono-data text-5xl tracking-tighter text-white" data-testid="score-value">
            {numericScore.toFixed(1)}
          </div>
          <div className="kpi-label mt-1">/ 10</div>
        </div>
      </div>
      <div className="flex-1">
        <div className="kpi-label mb-2" style={{ color: tone }}>/ ACCOUNT ATTRACTIVENESS</div>
        <p className="text-[15px] text-white leading-relaxed">{summary || "—"}</p>
      </div>
    </div>
  );
};

export default AccountScoreGauge;
